import classNames from "classnames";
import React from "react";
import { CgSpinner } from "react-icons/cg";
import { useConfig } from "../ConfigProvider";

export interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  children?: React.ReactNode;
  color?: string;
  enableTheme?: boolean;
  indicator?: React.ElementType<React.SVGProps<SVGSVGElement>>;
  isSpining?: boolean;
  size?: string | number;
}

const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>((props, ref) => {
  const {
    className,
    color,
    enableTheme,
    indicator: Component = CgSpinner,
    isSpining,
    size,
    style,
    ...rest
  } = props;

  const { themeColor, primaryColorLevel } = useConfig();

  const spinnerColor =
    color || (enableTheme && `${themeColor}-${primaryColorLevel}`);

  const spinnerStyle = {
    height: size,
    width: size,
    ...style,
  };

  const spinnerClass = classNames(
    isSpining && "animate-spin",
    spinnerColor && `text-${spinnerColor}`,
    className,
  );

  return (
    <Component
      ref={ref}
      style={spinnerStyle}
      className={spinnerClass}
      {...rest}
    />
  );
});

Spinner.defaultProps = {
  indicator: CgSpinner,
  isSpining: true,
  size: 20,
  enableTheme: true,
};

export default Spinner;
